import React from 'react';
import { Tooltip } from '@marvelapp/ui';
export default function TooltipWrap({ children, content, showTooltip }) {
    if (showTooltip) {
        return (React.createElement("div", { "data-testid": "tooltip-wrap" },
            React.createElement(Tooltip, { content: content, cursor: "default", whiteSpace: "wrap", width: 180 }, children)));
    }
    return children;
}
